import { render, staticRenderFns } from "./dashboard-page.vue?vue&type=template&id=e60a35ea"
import script from "./dashboard-page.vue?vue&type=script&lang=js"
export * from "./dashboard-page.vue?vue&type=script&lang=js"
import style0 from "./dashboard-page.vue?vue&type=style&index=0&id=e60a35ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports